import React from 'react'
import cx from 'classnames'
import { node, oneOf, string } from 'prop-types'

import styles from './Stack.module.scss'

import Element from '../Element'

const gaps = ['tiny', 'small', 'medium', 'large']
const Stack = ({ as, children, gap, className }) => (
  <Element as={as} className={cx(styles.Stack, gap && styles[gap], className)}>
    {children}
  </Element>
)

Stack.defaultProps = {
  gap: 'medium'
}

Stack.propTypes = {
  as: string,
  children: node.isRequired,
  gap: oneOf(gaps),
  className: string
}

export default Stack
